// import type { Ingredient, IngredientMarkedType } from '@/types';

interface IngredientMarkingTooltipProps {
  children: React.ReactNode;
  // ingredient: Ingredient;
  // onMark: (ingredient: Ingredient, markedType: IngredientMarkedType) => void;
}

export default function IngredientMarkingTooltip({
  children,
  // ingredient,
  // onMark,
}: IngredientMarkingTooltipProps) {
  // const handleIngredientMark = (markedType: IngredientMarkedType) => {
  //   onMark(ingredient, markedType)
  // };
  //
  // const handleTooltipActionClick = (markedType: IngredientMarkedType) => (event: React.MouseEvent | React.TouchEvent) => {
  //   event.stopPropagation()
  //
  //   handleIngredientMark(markedType)
  // }

  return children

  // // @TODO: insert tooltip component for long press/touch events
  // return (
  //   <div onClick={handleTooltipActionClick('SELFCART')}>
  //     {children}
  //   </div>
  // )
}
